import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { createForm, renderModalError } from '@utils/forms';
import { convertToInt, isUrlParamValid } from '@utils/helpers';
import { routes } from '@constants/routes';
import { showModal } from '@utils/modal';

import LicensorForm from '../forms/LicensorForm';
import LicensorModel from '../forms/LicensorModel';

const LicensorEdit = ({ match: { params: { id = null } } }) => {
    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('Licensor', routes.licensors.index.path),
        });
    }

    const Form = React.useMemo(
        () => createForm(LicensorModel, LicensorForm, { id: convertToInt(id) }),
        [id]
    );

    return <Form />;
};

LicensorEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(LicensorEdit);
